import HomeColumnComponent from './home-column-component';

/***
 * A single column on the home page, containing a header icon and title and a list of links.
 */
const homeColumn = angular
    .module('FacilityData.Home.HomeColumn', [])
    .component('homeColumn', HomeColumnComponent)
    .name;

export default homeColumn;


// WEBPACK FOOTER //
// ./app/components/home/home-column/home-column.js